
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const MailAttach20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="m10.77 10.47-.77.45L3 6.8v-.3C3 5.67 3.67 5 4.5 5h7.38l1-1H4.5A2.5 2.5 0 0 0 2 6.5v8A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5V9.12l-1 1v4.38c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l.83-.49c-.17-.3-.28-.63-.31-.97Zm4.46-6a1.62 1.62 0 0 1 2.3 2.3l-.02.01-3.85 3.85h-.01a.56.56 0 1 1-.78-.8l3.48-3.48a.5.5 0 1 0-.7-.7l-3.5 3.49-.02.02a1.56 1.56 0 0 0 2.21 2.2l.01-.01 3.88-3.87.01-.01a2.63 2.63 0 0 0-3.72-3.7l-3.57 3.57a.5.5 0 0 0 .7.7l3.58-3.56Z"
            fill="currentColor"
        />
    </svg>
}